/**
 * Column definitions for the Directory list view. The shape follows the same
 * pattern as `internalUsersConfig.js` / customers' headerConfig — static
 * structure here, per-column `onRenderProperty` callbacks attached by the
 * DesktopView (so they can access classes/handlers from the React context).
 */
export const headersTableConfig = [
	{
		title: 'TITLE',
		dataSource: 'Title',
		sortable: false,
		width: '32%'
	},
	{
		title: 'CATEGORY',
		dataSource: 'CategoryName',
		sortable: false,
		width: '15%'
	},
	{
		title: 'TAGS',
		dataSource: 'Tags',
		sortable: false,
		width: '20%'
	},
	{
		title: 'AUDIENCE',
		dataSource: 'Audience',
		sortable: false,
		width: '13%'
	},
	{
		title: 'CREATED',
		dataSource: 'CreationDate',
		sortable: false,
		width: '15%'
	},
	{
		title: '',
		dataSource: 'Actions',
		sortable: false,
		width: '5%'
	}
]
